import { PaddleAuthConnectRequestSchema } from '@vy/api-definition';
import type { oz } from '@vy/utils';
import type { Control } from 'react-hook-form';

export const PaddleRegisterFormSchema = PaddleAuthConnectRequestSchema;

export type PaddleRegisterFormValues = oz.infer<typeof PaddleRegisterFormSchema>;
export type PaddleRegisterControl = Control<PaddleRegisterFormValues>;
